import { render, staticRenderFns } from "./CustomWordingData.vue?vue&type=template&id=4cbbe7f0&"
import script from "./CustomWordingData.vue?vue&type=script&lang=js&"
export * from "./CustomWordingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports